export default __webpack_public_path__ + "static/media/bkg--team-1.522b014a.jpg";